import { isEntryOrAsset } from './isEntryOrAsset';
import type {
  IAnimation,
  ICodeBlock,
  ICustomHtml,
  IImage,
  ILogoGrid,
  IVideo
} from '~~/lib/ContentfulService';

export type IMedia =
  IAnimation | ICodeBlock | IImage | IVideo | ICustomHtml | ILogoGrid;

export type MediaTypeInterface = {
  image: IImage;
  video: IVideo;
  animation: IAnimation;
  customHtml: ICustomHtml;
  codeBlock: ICodeBlock;
  logoGrid: ILogoGrid;
};

export function isMediaType<T extends keyof MediaTypeInterface>(
  value: unknown,
  mediaType: T
): value is MediaTypeInterface[T] {
  return isEntryOrAsset(value) && mediaType === value.sys.contentType?.sys.id;
}
